import Css from "./style.module.scss";

import Activity from "nlib/common/Activity";
import CommentTargetTypes from "const/CommentTargetTypes";
import React from "react";
import useDocumentContext from "hooks/useDocumentContext";

const ActivityTab = () => {
  const { documentData } = useDocumentContext();

  return (
    <div className={Css.activityTab}>
      <Activity
        showAllInitial
        itemId={documentData.id}
        type={CommentTargetTypes.DOCUMENTS}
        commentsCount={documentData.comments} />
    </div>
  );
};

export default React.memo(ActivityTab);
